"use client";

import * as React from "react";
import { Logo } from "@/studio/sanity/Logo";

import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useRouter } from "next/navigation";
import Link from "next/link";
import { HomeIcon } from "@heroicons/react/24/solid";

export function LogoCamsDropdown({
  list,
  project,
}: {
  list: {
    id: string;
    name: string;
  }[];
  project: string;
}) {
  const router = useRouter();
  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <Button className="px-2 -ml-2" variant="ghost">
          <Logo className="h-6 w-6" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-auto" align="start">
        <DropdownMenuRadioGroup
          value={project}
          onValueChange={(value) => {
            router.push(`/cams/${value}`);
          }}
        >
          {list.map((item) => (
            <DropdownMenuRadioItem key={item.id} value={item.id}>
              {item.name}
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>

        <DropdownMenuSeparator />

        <DropdownMenuItem asChild>
          <Link href="/">
            <HomeIcon className="h-5 w-5 mr-2" />
            clarksullivan.com
          </Link>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
